import styled from '@emotion/styled/macro'

export const DateTimeRangePickerWrapper = styled.div`
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  left: 22%;
  padding: 24px;
  position: absolute;
  top: 35%;
  z-index: 101;
`

export const DateTimeRangePickerCancelButton = styled.span`
  color: #005cd9;
  font-size: 1.2em;
  padding: 2px;
  position: absolute;
  right: 8px;
  top: 8px;
  &:hover {
    color: rgba(66, 139, 227, 0.8);
    cursor: pointer;
  }
`
